<div class="vadtallogin-page">
    <div class="container">
        <div class="row">

            <div class="col-lg-6 col-12 order-lg-0 order-2">

                <div class="login-content verification-content">
                    <img src="../../../../assets/img/logo.svg" alt="logo" class="img-fluid loginlogo">
                    <h3 class="caption-login mb-3">{{verificationPageLabel.CHECK_YOUR_EMAIL}}</h3>
                    <p>{{verificationPageLabel.WE_SEND_A_CODE}}<strong
                            style="font-size:18px;color:#7B8185;font-weight:600;">{{emailAddress}}</strong></p>

                    <form class="mt-2" [formGroup]="verificationCodeForm" (ngSubmit)="verificationCode()">
                        <div
                            class="form-group mb-3 d-flex align-items-center justify-content-center gap-4 text-center otp-bar flex-wrap">
                            <ng-otp-input (onInputChange)="onOtpChange($event)" #ngOtpInput
                                [config]="config"></ng-otp-input>
                        </div>
                        <button class="btn btn-primary login-btn mt-3 mb-4"
                            type="submit">{{verificationPageLabel.CONTINUE}}</button>
                        <div class="mb-3 d-flex align-items-center justify-content-center resend-link">
                            Didn’t Receive The Email?<a (click)="ResendOTP()"
                                [ngClass]="{'disabled-link': isResendDisabled}">{{verificationPageLabel.CLICK_TO_RESEND}}</a>
                        </div>
                    </form>
                    <div class="expire-info">
                        <ng-template [ngIf]="counter!=0" [ngIfElse]="TimeExpired">
                            <p>{{verificationPageLabel.EXPIRE_IN}} <span>{{minutes}} : {{seconds}}</span></p>
                        </ng-template>
                        <ng-template #TimeExpired>
                            <p><span class="text-danger">{{verificationPageLabel.TIME_Expired}}</span></p>
                        </ng-template>
                    </div>
                    <div class="backtologin text-center mt-3"><a (click)="goLogin()"><svg xmlns="http://www.w3.org/2000/svg"
                                width="22" height="22" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                                <path fill-rule="evenodd"
                                    d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
                            </svg>&nbsp;&nbsp;{{verificationPageLabel.BACK_TO_LOGIN}}</a></div>
                </div>
            </div>
            <div class="col-lg-6 col-12 order-lg-0 order-1">
                <div class="login-rightside">
                    <img src="../../../../assets/img/login-rightimg.jpg" alt="login rightimg" class="img-fluid">
                </div>
            </div>

        </div>

    </div>



</div>